import { Component, h, Prop, Listen } from '@stencil/core';
import {
  createMoIframe,
  removeMoIframe,
  sendEvent,
  validMoClientId,
} from '../../utils/utils';

@Component({
  tag: 'mo-button',
  styleUrl: 'mo-button.css',
  shadow: true,
})
export class MoButton {
  @Prop() offerByPrice!: boolean;
  @Prop() price!: string;
  @Prop() gtagCategory!: string;
  @Prop() clientId!: string;
  @Prop() buttonType: string;
  @Prop() valueText: string;

  @Listen('closeIframe', { target: 'document' })
  closeIframeHandlerEvent(event: CustomEvent) {
    if (!!event) this.removeIframe();
  }

  private addIframe = (
    clientId: string,
    price: string,
    gtagCategory: string
  ) => {
    console.log(clientId)
    sendEvent(gtagCategory, 'click');
    return !!validMoClientId(clientId)
      ? createMoIframe(clientId, price)
      : console.warn('Invalid MO Client ID');
  };

  private removeIframe = () => removeMoIframe();

  render() {
    return (
      <button
        onClick={() =>
          this.addIframe(this.clientId, this.price, this.gtagCategory)
        }
        id='complex-btn'
        class={`mo-button-complex ${this.buttonType}`}
      >
        {this.valueText}
        {/* {this.buttonType === 'product' ? 'Ver más' : 'Más información'} */}
      </button>
    );
  }
}
